import { useContext } from "react";
import CheckUpContext from "../../context/check-up";
import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import localeData from "dayjs/plugin/localeData";
import "dayjs/locale/it";
import "dayjs/locale/fr";
import "dayjs/locale/es";
import "dayjs/locale/pt";
import PickUpPointsCard from "../pick-up-point-card";
dayjs.extend(LocalizedFormat);
dayjs.extend(localeData);

const CheckUpPickUpPointResume = () => {
  const { appLang, currentRequest, labels } = useContext(CheckUpContext);

  const clinic = currentRequest?.clinic;

  return (
    <div className="check-up-content__resume">
      {clinic && (
        <div className="app-content__title-wrapper">
          <h2 className="app-content__title">
            {currentRequest?.status === "DRAFT"
              ? labels?.WELFARE_CHECKUP_BOOKING_DRAFT_PLACE_INFO ||
                "Stai prenotando il Check up presso:"
              : labels?.WELFARE_CHECKUP_BOOKING_CONFIRMED_PLACE_INFO ||
                "Hai prenotato il Check up presso:"}
          </h2>
        </div>
      )}
      <div className="check-up-content__resume-wrapper">
        {clinic && (
          <div className="pick-up-points__point pick-up-points__point--read-only">
            <PickUpPointsCard point={clinic} clinic={true} labels={labels} />
          </div>
        )}
        <div className="check-up-content__resume-info">
          {currentRequest?.status === "IN_PROGRESS" && currentRequest?.firstExamDate && (
            <div className="app-content__text">
              <p>
                <strong>
                  {labels?.WELFARE_CHECKUP_FIRST_VISIT_DATE || "Data prima visita"}:{" "}
                  {dayjs(Number(currentRequest?.firstExamDate)).locale(appLang?.value).format("L")}
                </strong>
              </p>
            </div>
          )}
          {currentRequest?.status !== "DRAFT" && (
            <div
              className="app-content__text"
              dangerouslySetInnerHTML={{
                __html: (
                  labels?.WELFARE_CHECKUP_BOOKING_CONFIRMED_PLACE_INFO_INTRO ||
                  `<p class="small font-weight-medium">Caro collega, <br/>ti confermiamo la prenotazione del check-up presso [CLINIC]. Verrai ricontattato direttamente dalla clinica per fissare il primo appuntamento.</p>`
                ).replace("[CLINIC]", clinic.name),
              }}
            />
          )}
          <div className="app-content__text">
            <p
              className="mb-s"
              dangerouslySetInnerHTML={{
                __html:
                  currentRequest?.status === "DRAFT"
                    ? labels?.WELFARE_CHECKUP_DRAFT_CAPTION ||
                      "<strong>Una volta inviata la tua richiesta non potrai più modificarla</strong>"
                    : labels?.WELFARE_CHECKUP_SENT_CAPTION ||
                      "<strong>Devi disdire l'appuntamento?</strong>",
              }}
            />
          </div>
          <div
            className="app-content__text"
            dangerouslySetInnerHTML={{
              __html:
                currentRequest?.status === "DRAFT"
                  ? `<p class="small font-weight-medium">Eventuali disdette delle visite concordate dovranno essere comunicate alla clinica con un <strong>anticipo di almeno 24 ore</strong>. In mancanza di comunicazione nel termine indicato il check-up verrà interrotto, salvo gravi e documentati motivi di salute e familiari</p>`
                  : `<p class="small font-weight-medium">Contatta la clinica con un <strong>anticipo di almeno 24 ore</strong>. In mancanza di comunicazione nel termine indicato il check-up verrà interrotto, salvo gravi e documentati motivi di salute e familiari</p>`,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CheckUpPickUpPointResume;
